import script from "./MainMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMain.vue?vue&type=script&setup=true&lang=js"

import "./MainMain.vue?vue&type=style&index=0&id=2f5b0160&lang=css"
import "./MainMain.vue?vue&type=style&index=1&id=2f5b0160&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5b0160"]])

export default __exports__